import React from 'react';
import { Helmet } from 'react-helmet-async';

const SEO = ({ 
  title, 
  description, 
  keywords,
  canonicalUrl,
  ogImage,
  schemaMarkup 
}) => {
  const siteTitle = "Energy Spectrum - Solar Panel & Battery Installation Sydney | Clean Energy Without Limits";
  const fullTitle = title ? `${title} | Energy Spectrum` : siteTitle;
  const defaultDescription = "Leading solar panel and battery installation company in Sydney, NSW. 12 years industry experience. Residential & commercial solar systems, Sigenergy, Fox ESS, Goodwe, Sungrow batteries. Call 0404 844 257";
  const defaultKeywords = "solar panel installation Sydney, solar battery Sydney, solar company Sydney, solar installer Sydney, home battery storage Sydney, commercial solar NSW";

  return (
    <Helmet>
      {/* Primary Meta Tags */}
      <title>{fullTitle}</title>
      <meta name="title" content={fullTitle} />
      <meta name="description" content={description || defaultDescription} />
      <meta name="keywords" content={keywords || defaultKeywords} />
      <meta name="robots" content="index, follow" />
      <meta name="language" content="English" />
      <meta name="author" content="Energy Spectrum" />
      <meta name="geo.region" content="AU-NSW" />
      <meta name="geo.placename" content="Sydney" />
      <meta name="geo.position" content="-33.8688;151.2093" />
      
      {/* Canonical URL */}
      {canonicalUrl && <link rel="canonical" href={canonicalUrl} />}
      
      {/* Open Graph / Facebook */}
      <meta property="og:type" content="website" />
      <meta property="og:title" content={fullTitle} />
      <meta property="og:description" content={description || defaultDescription} />
      <meta property="og:site_name" content="Energy Spectrum" />
      {ogImage && <meta property="og:image" content={ogImage} />}
      
      {/* Twitter */}
      <meta name="twitter:card" content="summary_large_image" />
      <meta name="twitter:title" content={fullTitle} />
      <meta name="twitter:description" content={description || defaultDescription} />
      {ogImage && <meta name="twitter:image" content={ogImage} />}
      
      {/* Schema.org markup */}
      {schemaMarkup && (
        <script type="application/ld+json">
          {JSON.stringify(schemaMarkup)}
        </script>
      )}
    </Helmet>
  );
};

export default SEO;
